import React, { useContext, useState } from 'react'
import { AppContext } from '../../context/app'
import useTemplateHook from '../template/templateHook'

const TipJarButton = ({
  tipJarButtonInfo,
  btnStyle,
  className,
  isMobileView = false,
  activatePipMode = () => {},
}) => {
  const { customNavigate, getLinkUrl } = useTemplateHook()
  const { setTipJarModalConfig } = useContext(AppContext)
  const [hover, setHover] = useState(false)

  const buttonConfig = tipJarButtonInfo?.button_data?.button_config || {}

  const handleButtonClick = () => {
    if (!buttonConfig.generate_qr_code && !buttonConfig?.allow_multiple_links) {
      if (tipJarButtonInfo?.link?.data?.pip_enabled) {
        activatePipMode()
        window.open(`${getLinkUrl(tipJarButtonInfo.link)}`, '_blank')
        return
      }

      customNavigate('INDIRECT', tipJarButtonInfo.link)
      return
    }

    setTipJarModalConfig({
      generate_qr_code: buttonConfig.generate_qr_code,
      allow_multiple_links: buttonConfig?.allow_multiple_links,
      name: tipJarButtonInfo?.button_text,
      child_buttons: tipJarButtonInfo?.child_buttons,
      link: tipJarButtonInfo?.link,
      activatePipMode: activatePipMode,
    })
  }

  const getStyleValue = (parentKey, key, defaultValue) => {
    if (!buttonConfig[parentKey][key]) {
      return defaultValue ? defaultValue : ''
    }
    return buttonConfig[parentKey][key]
  }

  let hoverStyle = isMobileView
    ? {
        background: '#000',
      }
    : {
        backgroundImage: hover
          ? ` linear-gradient(to ${getStyleValue('highlight', 'gradient', 'left')}, ${getStyleValue(
              'highlight',
              'primary_color',
              '#ffd501',
            )}, ${getStyleValue('highlight', 'secondary_color', '#fb8c0e')})`
          : ` linear-gradient(to ${getStyleValue('style', 'gradient', 'left')}, ${getStyleValue(
              'style',
              'primary_color',
              '#ffd501',
            )}, ${getStyleValue('style', 'secondary_color', '#fb8c0e')})`,
        color: hover
          ? getStyleValue('highlight', 'text_color', '#ffffff')
          : getStyleValue('style', 'text_color', '#ffffff'),
      }

  return (
    <div
      className={`${className} `}
      style={{ ...btnStyle, zIndex: '50' }}
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <button
        style={{
          ...hoverStyle,
        }}
        className={` h-[28px] md:h-[34px] min-w-[107px] md:min-w-[152px] md:rounded-lg text-[10px] md:text-sm`}
        onClick={handleButtonClick}
      >
        {tipJarButtonInfo?.button_text}
      </button>
    </div>
  )
}

export default TipJarButton
